<div class="bmc-connect-provider-detail">
  <div class="bmc-connect-provider-detail__pl">
    <div class="bmc-connect-provider-detail__add-panel">
      <label class="bmc-connect-provider-detail__add-panel__text">{{ 'PROVIDERS.ADD_METADATA' | translate }}</label>
      <bzg-button-secondary type="button" (click)="addProperty()" [disabled]="disabledAddBtn()">
          {{ 'PROVIDERS.ADD_PROPERTY' | translate }}
      </bzg-button-secondary>
    </div>

    <div class="bmc-connect-provider-detail__list">
      <div class="bmc-connect-provider-detail__list__header">
        <label class="bmc-connect-provider-detail__list__header__left">{{ 'PROVIDERS.PROPERTIES' | translate }}</label>
        <label class="bmc-connect-provider-detail__list__header__right">{{ 'PROVIDERS.VALUE' | translate }}</label>
      </div>

      <ul class="bmc-connect-provider-detail__items">
        <li *ngFor="let propertyMetadata of propertiesMetadata">
          <div *ngIf="propertyMetadata.key !== 'TrustServerCertificate'">
            <div class="bmc-connect-provider-detail__list__item">
              <bzg-input type="text" class="bmc-connect-provider-detail__list__item__value bz-space--inline-m" placeholder="{{ 'PROVIDERS.PROPERTY' | translate }}" [(ngModel)]="propertyMetadata.key" (change)="changeProperty($event.target.value, propertyMetadata.position, true)" maxlength="25"></bzg-input>
              <bzg-input class="bmc-connect-provider-detail__list__item__value bz-space--inline-m" type="{{isEncrypt(propertyMetadata) ? 'password':'text'}}"  actionIcnPosition="right" placeholder="{{ 'PROVIDERS.VALUE' | translate }}" [(ngModel)]="propertyMetadata.value" (change)="changeProperty($event.target.value, propertyMetadata.position, false)" maxlength="1000" [title]="showTitle(propertyMetadata.key, propertyMetadata.value)" [pattern]="getServerPattern(propertyMetadata)">
                <bzg-icon *ngIf="showIcon(propertyMetadata) && hidePassword" (click)="showPassword(false)" class="bmc-connect-provider-detail__icon" nameIcon="icon-eye-off"></bzg-icon>
                <bzg-icon *ngIf="showIcon(propertyMetadata) && !hidePassword" (click)="showPassword(true)" class="bmc-connect-provider-detail__icon" nameIcon="icon-eye"></bzg-icon>
                <bzg-pattern-error *ngIf="shouldValidateServer(propertyMetadata)">{{ 'PROVIDERS.INVALID_SQL_SERVER_FORMAT' | translate }}</bzg-pattern-error>
              </bzg-input>

              <bzg-icon class="bmc-connect-provider-detail__icon" (click)="deleteProperty(propertyMetadata)" nameIcon="icon-delete"></bzg-icon>
            </div>
            <div *ngIf="duplicatedKeyReview(propertyMetadata)" class="showError">{{ 'PROVIDERS.SAME_KEY' | translate }}</div>
            <div *ngIf="characterSpecial(propertyMetadata)" class="showError">{{ 'PROVIDERS.DISALLOWED_CHARACTERS' | translate }}</div>
          </div>
        </li>
        <li class="provider-trust-server-certificate" *ngIf="isSqlServer">
          <label class="bmc-connect-provider-detail__list__item__value bz-space--inline-m">{{'PROVIDERS.TRUST_SERVER_CERTIFICATE' | translate}}</label>
          <bzg-radio-group isHorizontal="true" class="bz-space--stack-xs" (change)="changeTrustServerCertificate($event.value)" [name]="'trustServerCertificate'" [value]="getTrustServerCertificate()">
            <bzg-radio-button value="true">{{'PROVIDERS.TRUE' | translate}}</bzg-radio-button>
            <bzg-radio-button value="false">{{'PROVIDERS.FALSE' | translate}}</bzg-radio-button>
          </bzg-radio-group>
        </li>
      </ul>
    </div>
  </div>

  <div class="bmc-connect-provider-detail__footer">
    <bzg-button-secondary type="button"  (click)='onCancel()' class="bmc-connect-provider-detail__footer-space">
      {{'GLOBAL.CANCEL'| translate}}
    </bzg-button-secondary>

    <bzg-button-primary type="button"  (click)="saveAll()" [disabled]="disabledSaveBtn()">
      {{ 'PROVIDERS.SAVE' | translate }}
    </bzg-button-primary>
  </div>
</div>
